import React from 'react'

// styles
import { Row } from '../../containers/Home/Home.styled'
import { Rounded, Image, DownArrow } from './Card.styled'

// image
import Logo from '../../assets/svgs/logodark.svg'

import ArrowIcon from '../../assets/svgs/downarrow.svg'
// no longer needed

// components

const Discovery = () => {
  // no longer needed
  return (
    <Rounded>
        <Row style={{ borderBottom: '1px solid purple', marginBottom: '5px' }}>
            <Image src={Logo} alt="logo"/>
        </Row>

        <div style={{ width: '100%', height: '600px' }}>
          <iframe
            src="https://api.leadconnectorhq.com/widget/booking/5yVHyzE5gSXMfjEhEAwH"
            style={{ width: '100%', height: '100%', border: 'none', overflow: 'hidden' }}
            scrolling="yes"
            id="5yVHyzE5gSXMfjEhEAwH_1749488976027"
          ></iframe>
        </div>

        <DownArrow>
            <img src={ArrowIcon} alt="" />
        </DownArrow>
    </Rounded>
  )
}

export default Discovery
